import { useState, useEffect } from 'react';
import styles from './ContactUsCard.module.scss';
import LEAF_DARK from '../../../../../src/assets/images/icons/leaf-dark.svg';
import { Badge, Typography } from '@mui/material';
import { businessHourTiming } from '../../../../../commons/utils/utils';
import { config } from '../../../../../config';
import Link from 'next/link';

const ContactUsCard = ({ contactCardData = {} }) => {
  const [isOnline, setOnline] = useState(false);
  const [Online, setIsOnline] = useState(false);

  const contactList = {
    title: '888-488-3112',
    link: 'tel:+1-888-488-3112',
    showOnline: true,
    mail: 'contactus@relieffactor.com',
  };

  useEffect(() => {
    setOnline(
      businessHourTiming(
        config.supportHours.openTime,
        config.supportHours.closeTime
      )
    );
  }, []);

  useEffect(() => {
    setIsOnline(
      businessHourTiming(
        config.businessHours.openTime,
        config.businessHours.closeTime
      )
    );
  }, []);

  return (
    <>
      <div className={styles.contactUsExtender}>
        <div className={styles.container}>
          <div className={styles.contactUsMainContainer}>
            <div className={styles.contactUsContainer}>
              <div className={styles.contentContainer}>
                <div className={styles.contentTabContainer}>
                  <div>
                    <Typography variant="p3" color="primary.main">
                      Contact Us
                    </Typography>
                    <div>
                      <Link href={contactCardData?.link} underline="none">
                        <div className={styles.phoneNumberRow}>
                          <Typography
                            variant="p3"
                            color="primary.black"
                            component="span"
                            className={styles.phoneText}
                          >
                            Service
                          </Typography>
                          <div className={styles.phoneIconContainer}>
                            {contactCardData?.icon}
                          </div>
                          <Typography
                            variant="button1"
                            color="primary.main"
                            className={styles.phoneNumberContent}
                            component="p"
                          >
                            {contactCardData?.contactNumber}
                          </Typography>
                          <div className={styles.badgeContainer}>
                            <Badge
                              className={`${
                                isOnline
                                  ? styles.onlineStatus
                                  : styles.offlineStatus
                              }`}
                              sx={{
                                pr: 1,
                                color: 'warning',
                              }}
                              variant="dot"
                            />
                          </div>
                        </div>
                      </Link>
                      <div className={styles.timings}>
                        <Typography
                          variant="p3"
                          color="primary.black"
                          component="p"
                        >
                          {contactCardData?.timing}
                        </Typography>
                      </div>
                    </div>
                    <div>
                      <Link href={contactList?.link} underline="none">
                        <div className={styles.phoneNumberRow}>
                          <Typography
                            variant="p3"
                            color="primary.black"
                            component="span"
                            className={styles.phoneText}
                          >
                            Sales
                          </Typography>
                          <div className={styles.phoneIconContainer}>
                            {contactCardData?.icon}
                          </div>
                          <Typography
                            variant="button1"
                            color="primary.main"
                            className={styles.phoneNumberContent}
                            component="p"
                          >
                            {contactList?.title}
                          </Typography>
                          <div className={styles.badgeContainer}>
                            <Badge
                              className={`${
                                Online
                                  ? styles.onlineStatus
                                  : styles.offlineStatus
                              }`}
                              sx={{
                                pr: 1,
                                color: 'warning',
                              }}
                              variant="dot"
                            />
                          </div>
                        </div>
                      </Link>
                      <div className={styles.timings}>
                        <Typography
                          variant="p3"
                          color="primary.black"
                          component="p"
                        >
                          {contactList?.timing}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className={styles.openTimeRow}>
                      <Typography
                        variant="p3"
                        color="primary.black"
                        component="p"
                      >
                        {contactCardData?.timing}
                      </Typography>
                      <div className={styles.openTimeRow}>
                        <Typography
                          variant="p3"
                          color="primary.black"
                          component="p"
                        >
                          {contactList?.timing}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.businessInquiry}>
                  <Typography
                    variant="p3"
                    color="primary.black"
                    className={styles.mailContent}
                  >
                    <Link href={'/business-inquiry'}>
                      Submit a Business Inquiry
                    </Link>
                  </Typography>
                </div>
              </div>
              <div className={styles.iconContainer}>
                <LEAF_DARK />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsCard;
